import { CurrencyMaskModule } from "ng2-currency-mask";
import { CurrencyMaskConfig, CURRENCY_MASK_CONFIG } from "ng2-currency-mask/src/currency-mask.config";
 
export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
    align: "left",
    allowNegative: false,    
    precision: 2,
    prefix: "R$ ",
    suffix: "",
    decimal: ",",
    thousands: "."
};


// WEBPACK FOOTER //
// ./src/shared/UtilsConsts.ts